/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './breadcrumb.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/shared/breadcrumb/breadcrumb.component';
const styles_BreadcrumbComponent:any[] = [i0.styles];
export const RenderType_BreadcrumbComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_BreadcrumbComponent,data:{}});
function View_BreadcrumbComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'a',[['class',
      'link']],[[8,'href',4]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.href;
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (<any>_v.parent).context.$implicit.label;
    _ck(_v,1,0,currVal_1);
  });
}
function View_BreadcrumbComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.label;
    _ck(_v,0,0,currVal_0);
  });
}
function View_BreadcrumbComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'li',([] as any[]),
      [[2,'active',(null as any)]],(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_BreadcrumbComponent_2)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf'],ngIfElse:[1,'ngIfElse']},(null as any)),(_l()(),i1.ɵand(0,[['last',
          2]],(null as any),0,(null as any),View_BreadcrumbComponent_3))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = (_v.context.index < (_co.links.length - 1));
    const currVal_2:any = i1.ɵnov(_v,3);
    _ck(_v,2,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_v.context.index === _co.links.length);
    _ck(_v,0,0,currVal_0);
  });
}
export function View_BreadcrumbComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'ol',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i1.ɵdid(278528,
      (null as any),0,i2.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,
          i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_BreadcrumbComponent_1)),i1.ɵdid(802816,
      (null as any),0,i2.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],
      {ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:i3.BreadcrumbComponent = _v.component;
    const currVal_0:any = _co.classes;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.links;
    _ck(_v,3,0,currVal_1);
  },(null as any));
}
export function View_BreadcrumbComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-breadcrumb',
      ([] as any[]),(null as any),(null as any),(null as any),View_BreadcrumbComponent_0,
      RenderType_BreadcrumbComponent)),i1.ɵdid(573440,(null as any),0,i3.BreadcrumbComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const BreadcrumbComponentNgFactory:i1.ComponentFactory<i3.BreadcrumbComponent> = i1.ɵccf('admin-breadcrumb',
    i3.BreadcrumbComponent,View_BreadcrumbComponent_Host_0,{links:'links',color:'color'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvYnJlYWRjcnVtYi9icmVhZGNydW1iLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2JyZWFkY3J1bWIvYnJlYWRjcnVtYi5jb21wb25lbnQudHMuQnJlYWRjcnVtYkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxvbCBbbmdDbGFzc109XCJjbGFzc2VzXCI+PGxpICpuZ0Zvcj1cImxldCBsaW5rIG9mIGxpbmtzOyBsZXQgaT1pbmRleFwiIFtjbGFzcy5hY3RpdmVdPVwiaSA9PT0gbGlua3MubGVuZ3RoXCI+PGEgW2hyZWZdPVwibGluay5ocmVmXCIgKm5nSWY9XCJpIDwgbGlua3MubGVuZ3RoIC0gMTsgZWxzZSBsYXN0XCIgY2xhc3M9XCJsaW5rXCI+e3tsaW5rLmxhYmVsfX08L2E+PG5nLXRlbXBsYXRlICNsYXN0Pnt7bGluay5sYWJlbH19PC9uZy10ZW1wbGF0ZT48L2xpPjwvb2w+IiwiPGFkbWluLWJyZWFkY3J1bWI+PC9hZG1pbi1icmVhZGNydW1iPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXdHO01BQUE7TUFBMkU7SUFBeEU7SUFBSCxXQUFHLFNBQUg7SUFBMkU7SUFBQTs7OztvQkFBcUM7SUFBQTtJQUFBOzs7O29CQUFoTTtNQUFBO01BQWdGO2FBQUE7VUFBQSxnREFBNkY7VUFBQTs7SUFBdkU7SUFBQTtJQUF0QixXQUFzQixtQkFBdEI7OztJQUFwQztJQUE1QyxXQUE0QyxTQUE1Qzs7OztvQkFBeEI7TUFBQSwrRUFBQTtNQUFBO3FCQUFBLHlDQUF3QjtNQUFBLGdGQUFBO01BQUE7TUFBQTs7SUFBcEI7SUFBSixXQUFJLFNBQUo7SUFBNEI7SUFBSixXQUFJLFNBQUo7Ozs7b0JDQXhCO01BQUE7b0NBQUEsVUFBQTtNQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/breadcrumb/breadcrumb.component.ngfactory.ts